var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useUpdateEffect, useMountEffect } from '..';
/**
 * This hook provides a console log when the component mounts, updates and unmounts.
 *
 * @param componentName Provides the name of the component in which the life cycle is being logged
 * @param deps Dependencies list, as for `useEffect` hook
 */
export function useLifecycleLogger(componentName, deps) {
    useMountEffect(function () {
        console.log("".concat(componentName, " mounted"), __assign({}, deps));
        return function () { return console.log("".concat(componentName, " unmounted")); };
    });
    useUpdateEffect(function () {
        console.log("".concat(componentName, " updated"), __assign({}, deps));
    }, deps);
}
